module.exports = __webpack_public_path__ + "img/facebook.84839226.svg";